import { useCategories } from "../features/catalog/api";
import CategoryCard from "../features/catalog/CategoryCard";
import SCSpinner from "../components/loaders/SCSpinner";
import ErrorState from "../components/ui/ErrorState";
import useSEO from "../hooks/useSEO";

export default function Categories() {
  useSEO({ title: "Shop by Category", description: "Browse every category of smart electrical fittings and home automation products." });
  const { data: categories, isLoading, isError, refetch } = useCategories();

  return (
    <div className="px-4 py-6">
      <h1 className="mb-4 font-serif text-2xl text-ink">Categories</h1>
      {isLoading ? (
        <div className="flex justify-center py-16">
          <SCSpinner size={56} />
        </div>
      ) : isError ? (
        <ErrorState message="Couldn't load categories." onRetry={refetch} />
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {(categories ?? []).map((c) => (
            <CategoryCard key={c.id} category={c} />
          ))}
        </div>
      )}
    </div>
  );
}
